import { useCallback } from 'react';
import { pruneNilValues } from '@core/object';
import { sendPixelTrackingWithSession } from '@core/tracking';
import { FEED_SCROLL_END_VIDEOS } from '@core/widgets/tracking/endpoints';
import { useInViewportIds } from './useInViewportIds';
import { useTracking } from './useTracking';
/**
 * Hook to return callback which should be triggered on scroll
 * event of embed feed (debounced) to track thumbnails
 * in viewport at the moment when scroll ends.
 */
export const useTrackEmbedScrollEndVideos = () => {
    const { params, pixelTrackingData } = useTracking();
    const inViewportIds = useInViewportIds();
    return useCallback(() => {
        const ids = inViewportIds();
        if (ids.length > 0) {
            const pixelData = {
                event_properties: pruneNilValues({
                    ...pixelTrackingData,
                    _viewport_videos_ids: ids,
                }),
            };
            sendPixelTrackingWithSession({
                endpoint: FEED_SCROLL_END_VIDEOS,
                data: pixelData,
                host: params.api_host_tracking,
            });
        }
    }, [inViewportIds, params, pixelTrackingData]);
};
